import { useEffect, useMemo } from 'react';
import debounce from 'lodash-es/debounce';
import ResizeObserver from 'resize-observer-polyfill';

interface IObserver {
  element: HTMLElement | null;
  callback: ResizeObserverCallback;
}
const useResponsiveObserver = ({ element, callback }: IObserver): ResizeObserver => {
  const observer = useMemo(() => {
    return new ResizeObserver(debounce(callback, 200));
  }, [callback]);

  useEffect(() => {
    try {
      if (element) observer.observe(element);
    } catch (e) {
      // do nothing with the error;
    }
    return (): void => {
      if (element) observer.unobserve(element);
    };
  }, [element, observer]);

  return observer;
};

export const observerCallback = (
  entries: readonly ResizeObserverEntry[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue: (value: any) => void,
  breakpoint: number,
  shouldSetHeight?: true,
): void => {
  window.requestAnimationFrame(() => {
    for (const entry of entries) {
      if (shouldSetHeight) {
        setValue(breakpoint);
        return;
      }
      if (entry.contentRect.width) setValue(entry.contentRect.width <= breakpoint);
    }
  });
};

export default useResponsiveObserver;
